import { Controller } from 'stimulus'

export default class extends Controller {
  close() {
    this.element.remove()
  }

  escClose(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  connect() {
    this.boundEscClose = this.escClose.bind(this)
    document.addEventListener('keydown', this.boundEscClose)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundEscClose)
  }
}